module.exports = __webpack_public_path__ + "static/media/success-training.aed9c531.svg";